import { type App } from 'vue';

import { registerSharedPlugins } from '@deepidoo/deesplay-shared/plugins';

import { type CorePluginOptions } from './corePluginOptions';
import { setupAuthorization } from './authorization';
import { setupPinia } from './pinia';
import { setupRouter } from './router';
import { setupTanstack } from './tanstack';

export { type CorePluginOptions, defaultOptions } from './corePluginOptions';

export function registerCorePlugins(app: App, options?: Partial<CorePluginOptions>): void {
	registerSharedPlugins(app, options);
	app.use(setupPinia()).use(setupRouter(options)).use(setupTanstack()).use(setupAuthorization());
};